
import React, { Fragment } from 'react'

import routes from 'routes/public/tags'


export default () =>
  <Fragment>
    { routes }
  </Fragment>
